// plugins/login.js
import { defineNuxtPlugin } from '#app';
import { ref, readonly, createApp } from 'vue';
// import loginCom from '@/components/loginComponents/login.vue';

export default defineNuxtPlugin(async (nuxtApp) => {
  const loginCom = (await import('@/components/loginComponents/login.vue')).default;
  const modalInstance = createApp(loginCom);
  const modalRef = ref<InstanceType<typeof loginCom> | null>(null);
  const isOpen = ref(false);

	const open = () => {
    if (modalRef.value) {
      isOpen.value = true;
      modalRef.value.loginOpen();
    }
  };
  const close = () => {
    if (modalRef.value) {
      modalRef.value.loginClose();
    }
    isOpen.value = false;
  };
  const handleClosed = () => {
    isOpen.value = false;
  };

  nuxtApp.provide('loginCom', {
    open,
    close,
    isOpen: readonly(isOpen),
  });
  // 注册组件
  nuxtApp.vueApp.component('loginCom', {
    setup() {
      return () => h(loginCom, { ref: modalRef, onClose: handleClosed });
    },
  });
});
